import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { pathname: prevPathName } = prevProps.location
    const { pathname: pathName } = this.props.location
    if (prevPathName !== pathName) {
      window.scrollTo(0, 0)
    }
  }
  render() {
    return <React.Fragment />
  }
}

export default withRouter(ScrollToTop)
